module.exports = __webpack_public_path__ + "static/moonlitNightMoreModern2Arranged-c98a9600a5d47a71260014f264c848bb.mp3";